import { useLocation } from "react-router";
import AdminFirstStep from "components/register/admin-first-step";

const FirstStep = () => {
  const location = useLocation();

  const roleFromQuery = location.state?.role;

  if (roleFromQuery === "admin") {
    return <AdminFirstStep />;
  }
};

export default FirstStep;
